import React from 'react';
import { scrollToReviews } from '../../../services/product/productInteraction.js';
import translateService from '../../../common/translateService';
import common from '../../../common/common';
import ReviewStars from '../reviews/ReviewStars.jsx';
import './ProductHeader.scss';

const ProductHeader = (props) => {
    const handleScrollToReviews = () => {
        scrollToReviews(props.isMobile, props.reviewsRef);
    };

    return (
        <div className='prd-header'>
            <div className='prd-header-brand-and-review'>
                <h2>
                    <a href={common.getSiteUrl(props.brandUrl)}>
                        {props.brandName}
                    </a>
                </h2>
                <h2
                    className='prd-header-reviewlink'
                    onClick={handleScrollToReviews}>
                    {props.revCount > 0 ? (
                        <ReviewStars
                            count={props.revCount}
                            average={props.ratingAverage}
                            maxRating={5}
                        />
                    ) : (
                        translateService.get(`productDetail.writeAReview`)
                    )}
                </h2>
            </div>
            <div>
                <h1 name='product-title' itemProp='name'>
                    {props.title}
                </h1>
                {!props.isKit && props.option ? (
                    <h2>
                        {translateService.interpolate(
                            `productDetail.productCode`,
                            {
                                code: props.option.manufacturerCode,
                            }
                        )}
                    </h2>
                ) : (
                    <></>
                )}
            </div>
        </div>
    );
};

export default ProductHeader;
